import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Keyboard, Pagination, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import qs from 'query-string';
import {
  Menu,
  Table,
  Header,
  Dropdown,
  Modal,
  Button
} from 'semantic-ui-react';

import RichieAdContainer from './RichieAdContainer';
import LocalStorage from './LocalStorage';

const PreviewContainer = (props) => {
  const { uuid } = props.match.params;
  const { history, location } = props;
  let pageNumber = parseInt(location.hash.substring(1), 10);
  if (isNaN(pageNumber)) {
    pageNumber = 1;
  }

  let currentPos = 0;
  let startPos = 0;

  //const [adContainer, setAdContainer] = useState(null);
  const [events, setEvents] = useState([]);
  const [lastEvent, setLastEvent] = useState(null);
  const [richieReady, setRichieReady] = useState(false);
  const [adVisible, setAdVisible] = useState(false);
  const [adHasBeenVisible, setAdHasBeenVisible] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(pageNumber);
  const [totalPages, setTotalPages] = useState(null);

  const [swiper, setSwiper] = useState(null);

  const adContainer = useRef(null);
  const isInitialMount = useRef(true);

  useEffect( () => {
    if (swiper !== null) {
      isInitialMount.current = false;
    }
  }, [swiper]);

  useEffect(() => {
    if (!adContainer.current || !richieReady) {
      return;
    }
    if (adVisible === true) {
      adContainer.current.adBecameVisible();
      setAdHasBeenVisible(true);
    }
    if (adVisible === false && adHasBeenVisible === true) {
      adContainer.current.adWasDismissed();
      setAdHasBeenVisible(false);
    }
  }, [adVisible, richieReady]);

  const handleCreativeEvents = (type, payload) => {
    if (!swiper) {
      return;
    }

    if (type === 'drag') {
      currentPos = swiper.getTranslate();
      if (!startPos) {
        startPos = currentPos;
      }
      swiper.setTranslate(currentPos - payload.deltaX);
    } else if (type === 'dragEnd') {
      if (Math.abs(payload.deltaX) > 2 && payload.duration < 300) {
        swiper.slideToClosest();
        if (payload.deltaX > 0) {
          swiper.slideNext();
        } else {
          swiper.slidePrev();
        }
      } else {
        var moved = swiper.getTranslate() - startPos;
        var percentage = moved / swiper.width;
        if (percentage < -0.5) {
          swiper.slideNext();
        } else if (percentage > 0.5) {
          swiper.slideToClosest();
          swiper.slidePrev();
        } else {
          swiper.slideReset();
        }
      }
      currentPos = 0;
      startPos = 0;
    } else if (type === 'keyboardLeft') {
      swiper.slidePrev();
    } else if (type === 'keyboardRight') {
      swiper.slideNext();
    } else if (type === 'keyboardSpace') {
      swiper.slideNext();
    }
  };

  const handleAnalyticsEvents = (evt) => {
    setLastEvent(evt.name.join(':'));
    setEvents([...events, evt]);
  };

  const clearPersistedStorage = () => {
    localStorage.removeItem('fi.richie.persistedStore'); // remove persisted store from local storage
  };

  const clearEvents = () => {
    setEvents([]);
  };
  const showPersistedStorage = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const params = {
    modules: [Keyboard, Pagination, Navigation],
    navigation: true,
    pagination: { clickable: true },
    scrollbar: { draggable: true },
    keyboard: true,
    initialSlide: pageNumber - 1,
    onSwiper: (swiper) => {
      setSwiper(swiper);
      setTotalPages(swiper.slides.length);
    },
    onSlideChange: (swiper) => {
      setAdVisible(swiper.activeIndex === 2); // hard coded to slide 3
      setCurrentPage(swiper.activeIndex + 1);
      history.replace({ hash: `#${swiper.activeIndex + 1}`, search: location.search });
    }
  };

  const queryParams = qs.parse(location.search);

  return (
    <div className="richie-preview-container">
      {uuid && (
        <Swiper className="richie-swiper-container" {...params}>
          <SwiperSlide>
            <Header>Slide 1</Header>
          </SwiperSlide>
          <SwiperSlide>
            <Header>Slide 2</Header>
          </SwiperSlide>
          <SwiperSlide>
            {() => {
              return (
                <RichieAdContainer
                  ref={adContainer}
                  uuid={uuid}
                  useProduction={queryParams.p === '1'}
                  onCreativeEvent={(type, payload) =>
                    handleCreativeEvents(type, payload)
                  }
                  onAnalyticsEvent={(evt) => handleAnalyticsEvents(evt)}
                  onReady={() => setRichieReady(true)}
                />
              );
            }}
          </SwiperSlide>
          <SwiperSlide>
            <Header>Slide 4</Header>
          </SwiperSlide>
          <SwiperSlide>
            <div className="events">
              <Header>Received events</Header>
              <Table compact="very">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell collapsing>Event number</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Details</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {events.length === 0 && (
                    <Table.Row>
                      <Table.Cell>No events</Table.Cell>
                    </Table.Row>
                  )}
                  {events.map((evt) => {
                    return (
                      <Table.Row key={evt.eventNumber}>
                        <Table.Cell collapsing textAlign="right">
                          {evt.eventNumber}
                        </Table.Cell>
                        <Table.Cell>{evt.name.join(':')}</Table.Cell>
                        <Table.Cell>
                          {evt.duration ? `${evt.duration}s` : ''}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>
            </div>
          </SwiperSlide>
        </Swiper>
      )}
      <Menu fixed="bottom">
        <Menu.Item className="paginationContainer">
          Slide {currentPage} / {totalPages}{' '}
        </Menu.Item>
        <Menu.Item style={{ width: '150px' }}>
          Ad Visible: {adVisible.toString()}
        </Menu.Item>
        <Menu.Item>Last ad event: {lastEvent || 'None'}</Menu.Item>
        <Dropdown
          pointing="top right"
          upward
          item
          icon="wrench"
          closeOnChange={true}
        >
          <Dropdown.Menu>
            <Dropdown.Item onClick={showPersistedStorage}>
              Show persisted storage
            </Dropdown.Item>
            <Dropdown.Item onClick={clearEvents}>Clear events</Dropdown.Item>
            <Dropdown.Item onClick={clearPersistedStorage}>
              Clear persisted storage
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Menu>
      <Modal dimmer="inverted" open={modalOpen} onClose={closeModal}>
        <Modal.Header>Persisted storage</Modal.Header>
        <Modal.Content>
          <LocalStorage item="fi.richie.persistedStore" />
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={closeModal}>
            Close
          </Button>
          <Button
            negative
            icon="trash"
            labelPosition="right"
            content="Clear"
            onClick={clearPersistedStorage}
          />
        </Modal.Actions>
      </Modal>
    </div>
  );
};

PreviewContainer.propTypes = {
  match: PropTypes.shape({ params: PropTypes.object }),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    hash: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired
    })
  })
};

export default PreviewContainer;
